/**
 * Обмеження фото, які водій надсилає (затримка, закриття зміни) — ті самі, що на бекенді
 * (PhotoFileDTO, UploadShiftPhotoAction): до 3 МБ, JPG/PNG/WEBP. Перевіряємо на клієнті,
 * щоб водій побачив конкретну причину до надсилання, а не загальне «не вдалося» з 422.
 */
export const MAX_PHOTO_SIZE_BYTES = 3 * 1024 * 1024
export const ALLOWED_PHOTO_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp']

export const getPhotoValidationError = (file: File): string | null => {
    const ext = file.name.split('.').pop()?.toLowerCase() ?? ''
    if (!ALLOWED_PHOTO_EXTENSIONS.includes(ext)) {
        return `«${file.name}»: формат не підтримується (дозволено: JPG, PNG, WEBP)`
    }
    if (file.size > MAX_PHOTO_SIZE_BYTES) {
        const mb = (file.size / (1024 * 1024)).toFixed(1)
        return `«${file.name}»: розмір ${mb} МБ перевищує ліміт 3 МБ`
    }
    return null
}
